define('collections/conversation/conversations',[
    'underscore',
    'backbone',
    'moment',
    'utils',
    // services
    'services/api',
    // parent
    'src/plugins/infinite-collection',
    // models
    'models/conversation/conversation'
], function(
    _, Backbone, moment, U,
    // services
    API,
    // parent
    InfiniteCollection,
    // models
    MConversation
) {

    var CConversations = InfiniteCollection.extend({
        model: MConversation,

        files: 'attachments',

        state: {
            pageSize: 25
        },

        queryParams: {
            previewMessages: function() {
                return 1;
            },
        },

        url: function() {
            var url = 'conversations/';

            if (this.folder) {
                url = url + this.folder.toUpperCase() + '/';
            }

            if (this.user) {
                url = 'users/me/' + url;
            }

            if (this.unread) {
                url = url + 'new/';
            }

            return API.url(url);
        },

        // sort by date as UTC string (reverse chronological order)
        comparator: function(a, b) {
            if (!a.get('lastMessageDate')) {
                return -1;
            }

            if (!b.get('lastMessageDate')) {
                return 1;
            }

            return -a.get('lastMessageDate').localeCompare(b.get('lastMessageDate'));
        },

        parse: function(data) {
            var collectionCopy = _.map(data.collection, _.clone);
            data.collection = this.removeMultipleUserConversation(data);

            // Adjusting collection total if multipel user conversation has been removed
            if (collectionCopy.length !== data.collection.length) {
                data.total = collectionCopy.length = data.collection.length;
            }

            if (data._users) {
                this._users = data._users;
                this.setConversationUsers(data);
            }
            return CConversations.__super__.parse.call(this, data);
        },

        initialize: function(models, opt) {
            opt = opt || {};

            this.setUser(opt.user);
            this.setGroup(opt.group);
        },

        setConversationUsers: function(data) {
            _.each(data.collection, function(conversationObj) {
                conversationObj._users = data._users;
            }, this);
        },

        /**
          We currently doesn't support multiple user conversation.
          For version 1, will notice the user that these conversations aren't compatible with the system & for that reason, they are not displayed
          Will ask the user if he wants to convert his multiple user conversation to be supported in the new software in 2nd phase
        **/

        removeMultipleUserConversation: function(data) {
            return _.reject(data.collection, function(conversationObj) {
                return conversationObj.users.length > 2;
            });
        },

        onSync: function() {
            this.setConversationUsers();
            this.setElement(this.getMostRecent());
        },

        setUser: function(userId) {
            this.user = userId;
            return this;
        },

        setGroup: function(groupId) {
            this.group = groupId;
            return this;
        },

        setFolder: function(folder) {
            this.folder = folder;
            return this;
        },

        getUsers: function() {
            return this._users;
        },

        getUnreadCount: function() {
            var unreadCollection = this.filter(function(model) {
                return model.isRead() === false;
            });

            return unreadCollection.length;
        },

        findByUser: function(userId) {
            return this.find(function(model) {
                return model.hasUser(userId);
            }, this);
        },

        getAllMessages: function() {
            var messages = [];
            this.map(function(model) {
                return messages.push(_.first(model.getMessages()));
            });
            return messages;
        },

        getMostRecent: function() {
            var dates = _.map(this.pluck('lastMessageDate'), function(date) {
                return moment(date);
            });

            return _.find(this.models, function(model) {
                return moment(model.get('lastMessageDate')).isSame(_.max(dates));
            });
        },

        getElement: function() {
            return this.currentElement;
        },

        setElement: function(model) {
            this.currentElement = model ? model : this.first();
        },

        next: function() {
            this.setElement(this.at(this.indexOf(this.getElement()) + 1));
            return this;
        },

        prev: function() {
            this.setElement(this.at(this.indexOf(this.getElement()) - 1));
            return this;
        },

        getFirstPage: function(opt) {
            opt = opt || {};
            if (opt.unread) this.unread = opt.unread;

            return CConversations.__super__.getFirstPage.call(this, opt);
        },

        fetch: function(opt) {
            opt = opt || {};
            if (opt.user) this.user = opt.user;

            return CConversations.__super__.fetch.call(this, opt);
        },

        bulkCreate: function(options) {
            options = _.extend({}, options, {
                url: _.result(this, 'url') + 'bulk_create/',
            });
            return this.sync("create", this, options);
        },

        markAllAsRead: function(options) {
            this.folder = null;

            options = _.extend({}, options, {
                url: _.result(this, 'url') + 'markAllRead/',
            });

            return this.sync("patch", this, options);
        },

        // This could be it's own collection "file-upload-collection" then CConversations would extend it
        sync: function(method, collection, options) {
            if (options.file && options.file.length != 0) {
                var methodMap = Backbone.Model.methodMap;
                var formData = new FormData();

                formData.append('_method', methodMap[method]);
                // Models contains every message to each user
                formData.append('_json', JSON.stringify(this.models));

                var fieldName = this.files;

                options.file.forEach(function(file) {
                    if(!isFile(file.get(fieldName))) {
                        return;
                    }

                    formData.append(fieldName + '[]', file.get(fieldName));
                });

                // Set processData and contentType to false so data is sent as FormData
                _.defaults(options || (options = {}), {
                    data: formData,
                    processData: false,
                    contentType: false
                });

                // reset the method to 'create' (so a POST) as this is the only
                // accepted method from the php API at the moment.
                method = 'create';
            }

            return CConversations.__super__.sync.call(this, method, collection, options);
        },

    });

    return CConversations;

    function isFile(data) {
        return data instanceof Blob || data instanceof File;
    }

});

